import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const API = process.env.REACT_APP_BACKEND_URL;

function Stat({ label, value, testId, i }) {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.08 * i }} className="rounded-xl border border-white/[0.08] bg-white/[0.02] px-5 py-4" data-testid={testId}>
      <div className="text-2xl md:text-3xl font-bold font-mono text-white" data-testid={`${testId}-value`}>{value}</div>
      <div className="text-[11px] uppercase tracking-widest text-gray-500 mt-1">{label}</div>
    </motion.div>
  );
}

export function GateUsageCounter() {
  const [u, setU] = useState(null);
  useEffect(() => {
    const load = () => fetch(`${API}/api/binding/usage`, { cache: 'no-store' }).then((r) => r.json()).then(setU).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!u) return null;
  const since = u.refusals_counted_since ? new Date(u.refusals_counted_since).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : 'launch';
  return (
    <div className="mt-8 max-w-3xl" data-testid="gate-usage-counter">
      <div className="grid grid-cols-3 gap-3">
        <Stat i={0} label="Executed checks" value={u.executed.toLocaleString('en-US')} testId="gate-usage-executed" />
        <Stat i={1} label="Refusals" value={u.refusals.toLocaleString('en-US')} testId="gate-usage-refusals" />
        <Stat i={2} label="Fees collected" value={`$${u.fees_usdc.toFixed(2)}`} testId="gate-usage-fees" />
      </div>
      <p className="text-[11px] text-gray-500 mt-2" data-testid="gate-usage-note">Totals before the pause. Executed checks include free demo receipts ({u.paid_executed} paid). Refusals counted since {since}. Fees are USDC on Base, paid executions only.</p>
    </div>
  );
}
